"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getOssDomain = function getOssDomain() {
  var hostname = window.location.hostname;

  if (hostname === 'm-sf.bingex.com') {
    return 'https://file-sf.bingex.com';
  } else if (hostname === 'm-l.bingex.com') {
    return 'https://file-l.bingex.com';
  } else if (hostname === 'm.ishansong.com' || hostname === 'market.ishansong.com') {
    return 'https://fileapi.ishansong.com';
  } else if (hostname === 'm-astable.bingex.com' || hostname === 'market-astable.bingex.com') {
    return 'https://file-astable.bingex.com';
  } else if (hostname === 'm-bstable.bingex.com' || hostname === 'market-bstable.bingex.com') {
    return 'https://file-bstable.bingex.com';
  } else if (hostname === 'm-cstable.bingex.com' || hostname === 'market-cstable.bingex.com') {
    return 'https://file-cstable.bingex.com';
  } else if (hostname === 'm-dstable.bingex.com' || hostname === 'market-dstable.bingex.com') {
    return 'https://file-dstable.bingex.com';
  } else if (hostname.includes('.fat.bingex.com')) {
    var fatName = hostname.replace(/[^\d]/g, '');
    return "".concat(window.location.protocol, "//file-stable-").concat(fatName, ".fat.bingex.com");
  } else {
    return 'https://file-astable.bingex.com';
  }
};

var getSellerOssDomain = function getSellerOssDomain() {
  var hostname = window.location.hostname;
  var ossDomain = {};

  switch (hostname) {
    case 'm-seller-s.bingex.com':
      ossDomain.svDomain = 'https://file-s.bingex.com';
      ossDomain.imgDomain = 'https://file-s.bingex.com';
      return ossDomain;

    case 'm-seller-ss.bingex.com':
      ossDomain.svDomain = 'https://file-ss.bingex.com';
      ossDomain.imgDomain = 'https://file-ss.bingex.com';
      return ossDomain;

    case 'm-seller-sf.bingex.com':
      ossDomain.svDomain = 'https://file-sf.bingex.com';
      ossDomain.imgDomain = 'https://file-sf.bingex.com';
      return ossDomain;

    case 'm-seller-astable.bingex.com':
      ossDomain.svDomain = 'https://file-astable.bingex.com';
      ossDomain.imgDomain = 'https://file-astable.bingex.com';
      return ossDomain;

    case 'm-seller-bstable.bingex.com':
      ossDomain.svDomain = 'https://file-bstable.bingex.com';
      ossDomain.imgDomain = 'https://file-bstable.bingex.com';
      return ossDomain;

    case 'm-seller-cstable.bingex.com':
      ossDomain.svDomain = 'https://file-cstable.bingex.com';
      ossDomain.imgDomain = 'https://file-cstable.bingex.com';
      return ossDomain;

    case 'm-seller-dstable.bingex.com':
      ossDomain.svDomain = 'https://file-dstable.bingex.com';
      ossDomain.imgDomain = 'https://file-dstable.bingex.com';
      return ossDomain;

    case 'mseller.ishansong.com':
      ossDomain.svDomain = 'https://fileapi.ishansong.com';
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com';
      return ossDomain;
  }

  if (hostname.match('172.')) {
    ossDomain.falseDomain = 'http://172.23.0.36:5540';
    ossDomain.svDomain = 'https://file-cstable.bingex.com';
    ossDomain.imgDomain = 'https://file-cstable.bingex.com';
    return ossDomain;
  }
};

var ossKey = {
  courier_storage: 'courier_storage',
  user_storage: 'user_storage',
  order_storage: 'order_storage',
  idcard_storage: 'idcard_storage',
  system_storage: 'system_storage',
  hdf_shop_storage: 'hdf_shop_storage',
  order_equipment_authenticatison: 'order_equipment_authenticatison',
  courier_aceExamine_storage: 'courier_aceExamine_storage',
  excel_short_storage: 'excel_short_storage',
  custom_service_storage: 'custom_service_storage',
  ocr_short_storage: 'ocr_short_storage'
};

var base64ToBlob = function base64ToBlob(base64Data) {
  var arr = base64Data.split(',');
  var fileType = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var l = bstr.length;
  var u8Arr = new Uint8Array(l);

  while (l--) {
    u8Arr[l] = bstr.charCodeAt(l);
  }

  return new Blob([u8Arr], {
    type: fileType
  });
};

var blobToFile = function blobToFile(newBlob, fileName) {
  if (!fileName) {
    fileName = new Date().valueOf();
  }

  newBlob.lastModifiedDate = new Date();
  newBlob.name = fileName;
  return newBlob;
};

var dataURLtoFile = function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {
    type: mime
  });
};

var downloadFile = function downloadFile(url) {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.style.height = 0;
  iframe.src = url;
  document.body.append(iframe);
  setTimeout(function () {
    iframe.remove();
  }, 5 * 60 * 1000);
};

var downLoadImgByBase64 = function downLoadImgByBase64(base64StrArr) {
  base64StrArr.forEach(function (base64Str, index) {
    var name = index + 1;
    var base64 = base64Str.toString();
    var byteCharacters = atob(base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
    var byteNumbers = new Array(byteCharacters.length);

    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
      type: undefined
    });
    var aLink = document.createElement('a');
    aLink.download = "".concat(name, ".jpg");
    aLink.href = URL.createObjectURL(blob);
    aLink.click();
  });
};

var _default = {
  downLoadImgByBase64: downLoadImgByBase64,
  dataURLtoFile: dataURLtoFile,
  getSellerOssDomain: getSellerOssDomain,
  downloadFile: downloadFile,
  base64ToBlob: base64ToBlob,
  blobToFile: blobToFile,
  getOssDomain: getOssDomain,
  ossKey: ossKey
};
exports["default"] = _default;